import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { mobileQuery } from '../../../utils';

export const OfflineInfo = () => {
  return (
    <Container>
      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon1}></NumberIcon>
          <Title>
            메인이벤트 DAY 1 <span>▶</span> 메인 이벤트 참가 티켓 소지자
          </Title>
        </TitleContainer>
        <Content>
          <ContentLeft>
            <VenueText>인천 파라다이스 시티</VenueText>
            <AddressText>인천 중구 영종해안남로321번길 186</AddressText>
          </ContentLeft>
          <ContentRight>
            <DateText>2025년 5월 17일(토) 오후 12시 시작</DateText>
            <EntranceText>11시 30분 부터 입장이 가능합니다</EntranceText>
          </ContentRight>
        </Content>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon2}></NumberIcon>
          <Title>
            메인이벤트 DAY 2 <span>▶</span> DAY 2 참가 티켓 소지자
          </Title>
        </TitleContainer>
        <Content>
          <ContentLeft>
            <VenueText>인천 파라다이스 시티</VenueText>
            <AddressText>인천 중구 영종해안남로321번길 186</AddressText>
          </ContentLeft>
          <ContentRight>
            <DateText>2025년 5월 18일(일) 오후 12시 시작</DateText>
            <EntranceText>11시 30분 부터 입장이 가능합니다</EntranceText>
          </ContentRight>
        </Content>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon3}></NumberIcon>
          <Title>사이드 이벤트</Title>
        </TitleContainer>
        <Content>
          <ContentLeft>
            <VenueText>인천 파라다이스 시티</VenueText>
            <AddressText>인천 중구 영종해안남로321번길 186</AddressText>
          </ContentLeft>
          <ContentRight>
            <DateText>2025년 5월 16일(금) 오후 12시 시작</DateText>
            <EntranceText>11시 30분 부터 입장이 가능합니다</EntranceText>
          </ContentRight>
        </Content>
      </Item>
    </Container>
  );
};

const Container = styled.div`
  max-width: 820px;
  margin: 0 auto;
`;

const Item = styled.div`
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);

  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }
  ${mobileQuery} {
    margin-bottom: 10px;
    padding-top: 0;
    padding-bottom: 10px;
  }
`;

const TitleContainer = styled.div`
  margin-bottom: 7px;
  display: flex;
  align-items: center;
`;

const Title = styled.h3`
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  span {
    font-size: 16px;
    position: relative;
    top: -2px;
  }

  ${mobileQuery} {
    font-size: 14px;
    line-height: 17px;

    span {
      font-size: 10px;
      top: -1px;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 40px;

  ${mobileQuery} {
    padding-left: 20px;
  }
`;

const ContentLeft = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;

  ${mobileQuery} {
    flex-direction: column;
  }
`;

const ContentRight = styled.div`
  display: flex;
  justify-content: space-between;

  ${mobileQuery} {
    flex-direction: column;
  }
`;

const VenueText = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);

  ${mobileQuery} {
    font-size: 13px;
    line-height: 18px;
  }
`;

const DateText = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 16px;
  }
`;

const AddressText = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.4);

  ${mobileQuery} {
    font-size: 12px;
    line-height: 16px;
  }
`;

const EntranceText = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 16px;
  }
`;

const NumberIcon = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 6px;

  ${mobileQuery} {
    width: 18px;
    height: 18px;
    margin-right: 6px;
  }
`;
